(function () {
  'use strict';

  var api = window.FalienneShopDrawer || {};
  var instances = api.instances || new Map();
  var bodyLock = api.bodyLock || { count: 0, overflow: '' };

  function lockBody() {
    if (bodyLock.count === 0) bodyLock.overflow = document.body.style.overflow;
    bodyLock.count += 1;
    document.body.classList.add('falienne-shop-drawer-open');
  }

  function unlockBody() {
    if (bodyLock.count > 0) bodyLock.count -= 1;
    if (bodyLock.count === 0) {
      document.body.classList.remove('falienne-shop-drawer-open');
      document.body.style.overflow = bodyLock.overflow;
      bodyLock.overflow = '';
    }
  }

  function focusableElements(dialog) {
    return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return element.getClientRects().length > 0; });
  }

  function Drawer(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-falienne-shop-dialog]');
    this.trigger = root.querySelector('[data-falienne-shop-trigger]');
    this.closeButton = root.querySelector('[data-falienne-shop-close]');
    this.previousTrigger = null;
    this.bodyLocked = false;
    this.supportsDialog = Boolean(this.dialog && typeof this.dialog.showModal === 'function');

    if (!this.dialog || !this.trigger || !this.supportsDialog) return;

    this.onTriggerClick = this.open.bind(this);
    this.onCloseClick = this.close.bind(this);
    this.onCancel = this.handleCancel.bind(this);
    this.onDialogClick = this.handleDialogClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);
    this.onDialogClose = this.handleClose.bind(this);

    this.trigger.addEventListener('click', this.onTriggerClick);
    this.closeButton.addEventListener('click', this.onCloseClick);
    this.dialog.addEventListener('cancel', this.onCancel);
    this.dialog.addEventListener('click', this.onDialogClick);
    this.dialog.addEventListener('close', this.onDialogClose);
  }

  Drawer.prototype.open = function (event) {
    if (!this.supportsDialog || this.dialog.open) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.previousTrigger = document.activeElement === this.trigger ? this.trigger : this.trigger;
    this.dialog.showModal();
    lockBody();
    this.bodyLocked = true;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.closeButton.focus();
    document.addEventListener('keydown', this.onKeydown);
  };

  Drawer.prototype.close = function () {
    if (!this.dialog || !this.dialog.open) return;
    this.dialog.close();
  };

  Drawer.prototype.handleCancel = function (event) {
    event.preventDefault();
    this.close();
  };

  Drawer.prototype.handleDialogClick = function (event) {
    if (event.target !== this.dialog) return;
    var bounds = this.dialog.getBoundingClientRect();
    var isBackdrop = event.clientX < bounds.left || event.clientX > bounds.right ||
      event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (isBackdrop) this.close();
  };

  Drawer.prototype.handleKeydown = function (event) {
    if (!this.dialog.open) return;
    if (event.key !== 'Tab') return;
    var elements = focusableElements(this.dialog);
    if (!elements.length) return;
    var first = elements[0];
    var last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Drawer.prototype.handleClose = function () {
    this.cleanup(!this.isDestroying);
  };

  Drawer.prototype.cleanup = function (restoreFocus) {
    document.removeEventListener('keydown', this.onKeydown);
    if (this.bodyLocked) {
      unlockBody();
      this.bodyLocked = false;
    }
    this.trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && this.previousTrigger && this.previousTrigger.isConnected) this.previousTrigger.focus();
  };

  Drawer.prototype.destroy = function () {
    if (!this.supportsDialog) return;
    this.isDestroying = true;
    if (this.dialog.open) this.dialog.close();
    this.cleanup(false);
    this.trigger.removeEventListener('click', this.onTriggerClick);
    this.closeButton.removeEventListener('click', this.onCloseClick);
    this.dialog.removeEventListener('cancel', this.onCancel);
    this.dialog.removeEventListener('click', this.onDialogClick);
    this.dialog.removeEventListener('close', this.onDialogClose);
    document.removeEventListener('keydown', this.onKeydown);
  };

  function init(root) {
    if (!root || instances.has(root)) return;
    var instance = new Drawer(root);
    instances.set(root, instance);
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-falienne-shop-drawer]')) init(scope);
    (scope || document).querySelectorAll('[data-falienne-shop-drawer]').forEach(init);
  }

  function unload(scope) {
    if (!scope) return;
    var roots = scope.matches && scope.matches('[data-falienne-shop-drawer]')
      ? [scope]
      : Array.from(scope.querySelectorAll ? scope.querySelectorAll('[data-falienne-shop-drawer]') : []);
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
      instances.delete(root);
    });
  }

  api.instances = instances;
  api.bodyLock = bodyLock;
  api.initAll = initAll;
  window.FalienneShopDrawer = api;

  if (document.readyState === 'loading') {
    if (!api.domReadyBound) {
      document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
      api.domReadyBound = true;
    }
  } else {
    initAll();
  }

  if (!api.lifecycleBound) {
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
    api.lifecycleBound = true;
  }
}());
